import useCountryTableColumns from './useCountryTableColumns'
export default useCountryTableColumns
